module.exports = __webpack_public_path__ + "assets/tutorials/Viewing_Results.png";